import React from 'react';
import PropTypes from 'prop-types';
import { Link, graphql } from 'gatsby';
import styled from 'styled-components';
import { v4 } from 'uuid';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Container from '../components/Container';
import {
  Hero,
  HeroHeading,
  SectionTitle,
  SmallSectionTitle,
  BodyText
} from '../components/Global';
import PricingSlider from '../components/PricingSlider';
import FaqDrop from '../components/FaqDrop';
import Icon from '../components/Icon';
import SimplifyTeamWork from '../components/SimplifyTeamWork';

import { theme } from '../styles/GlobalStyles';
import MediaBreakDown from '../styles/MediaBreakDown';

const HeroWrap = styled(Hero)`
  margin-bottom: 0px;
`;

const TableSection = styled.div`
  width: 100%;
  max-width: 1327px;
  margin: auto;
  ${MediaBreakDown.xl`
    display: none;
  `}
`;
const FaqsSection = styled.div`
  width: 100%;
  max-width: 767px;
  margin: 133px auto 76px;
  a {
    color: ${theme.hover.hoverBlue};
  }
`;

const PricingPage = ({ data, location }) => (
  <Layout location={location}>
    <SEO title="Pricing" description="Workast Pricing Page" />
    <Container>
      <HeroWrap>
        <HeroHeading mb="20px">A plan for every team</HeroHeading>
        <BodyText>Get started for free. No credit card required.</BodyText>
      </HeroWrap>
      <div className="centered-text">
        <PricingSlider />
        <TableSection>
          <SectionTitle mb="36px">Compare our plans</SectionTitle>
          <table className="plan-table tablet-hidden">
            <tr>
              <th>Our Plans</th>
              <th>Essential</th>
              <th>Standard</th>
              <th>Pro</th>
              <th>Enterprise</th>
            </tr>
            <tr>
              <td>Tasks</td>
              <td>30 day retention</td>
              <td>Unlimited</td>
              <td>Unlimited</td>
              <td>Unlimited</td>
            </tr>
            <tr>
              <td>Meetings</td>
              <td>30 day retention</td>
              <td>Unlimited</td>
              <td>Unlimited</td>
              <td>Unlimited</td>
            </tr>
            <tr>
              <td>Notes</td>
              <td>30 day retention</td>
              <td>Unlimited</td>
              <td>Unlimited</td>
              <td>Unlimited</td>
            </tr>
            <tr>
              <td>Storage</td>
              <td>100 mb</td>
              <td>1 GB / user</td>
              <td>5 GB / User</td>
              <td>10 GB / User</td>
            </tr>
            <tr>
              <td>Support</td>
              <td>Help Center</td>
              <td>Email & Chat</td>
              <td>Email & Chat</td>
              <td>Dedicated Account manager</td>
            </tr>
            <tr>
              <td>Slack integration</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Public Spaces</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Email integration</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>API</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>3rd party integrations (Zapier, Bitbucket, Google Drive)</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>iOS and Android Apps</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Board view</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Calendar view</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Custom lists</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Forms</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Quick search</td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Advanced search</td>
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Custom reports and reminders</td>
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Export reports to CSV</td>
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Private spaces</td>
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>2 way calendar sync</td>
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Guest users</td>
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Upgrade only your department</td>
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Subtasks</td>
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Custom tags</td>
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Templates</td>
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Time tracking</td>
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Task dependencies</td>
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Support for multiple workspaces</td>
              <td />
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Advanced cross team reporting and resource allocation</td>
              <td />
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Activity logs</td>
              <td />
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
            <tr>
              <td>Custom security preferences</td>
              <td />
              <td />
              <td />
              <td>
                <Icon name="checkIcon" color={theme.icon.blueIcon} />
              </td>
            </tr>
          </table>
        </TableSection>
        <FaqsSection>
          <SmallSectionTitle mb="65px">Frequently Asked Questions</SmallSectionTitle>
          {
            data.allContentfulFaq.edges.map(item => (
              <FaqDrop data={item.node} key={v4()} />
            ))
          }
          <Link to="/help">Go to help center</Link>
        </FaqsSection>
        <SimplifyTeamWork />
      </div>
    </Container>
  </Layout>
);

PricingPage.propTypes = {
  data: PropTypes.shape({
    allContentfulFaq: PropTypes.shape({
      edges: PropTypes.shape({
        map: PropTypes.shape({
          node: PropTypes.shape({
            question: PropTypes.string.isRequired,
            answer: PropTypes.element.isRequired,
          }).isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    host: PropTypes.string,
    hostname: PropTypes.string,
    href: PropTypes.string,
    key: PropTypes.string,
    origin: PropTypes.string,
    pathname: PropTypes.string,
    port: PropTypes.string,
  }).isRequired,
};

export default PricingPage;

export const pageQuery = graphql`
  query PricingPageQuery {
    allContentfulFaq(sort: {order: ASC, fields: order}) {
      edges {
        node {
          question
          answer {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`;
